/* INTEGY V520/V558 — single-owner buyer model navigation and compact filter presentation.
   Compatible models are navigation (single choice), never faceted checkboxes.
   Current model is authoritative, conflicting scale/platform tags are removed
   when switching models, and the expansion/search controls remain stable. */
(function () {
  'use strict';
  if (window.IntegyV520FilterExperience) return;

  window.INTEGY_V520_FILTER_PRESENTATION = true;
  window.INTEGY_V515_FILTER_PRESENTATION = true;
  window.INTEGY_FILTER_PRESENTATION_OWNER = 'V520';

  var root = document.documentElement;
  var timer = 0;
  var observer = null;
  var applying = false;

  function one(selector, scope) {
    try { return (scope || document).querySelector(selector); }
    catch (error) { return null; }
  }

  function all(selector, scope) {
    try { return Array.prototype.slice.call((scope || document).querySelectorAll(selector)); }
    catch (error) { return []; }
  }

  function clean(value) {
    return String(value == null ? '' : value).replace(/\s+/g, ' ').trim();
  }

  function normalizeModelSearch(value) {
    var normalized = clean(value).toLowerCase();
    try { normalized = normalized.normalize('NFKD').replace(/[\u0300-\u036f]/g, ''); }
    catch (error) {}
    return normalized.replace(/[\u2010-\u2015\u2212]/g, '-').replace(/[^a-z0-9]+/g, ' ').replace(/\s+/g, ' ').trim();
  }

  function modelMatches(label, query) {
    if (!query) return true;
    var searchable = normalizeModelSearch(label);
    return searchable.indexOf(query) >= 0 || searchable.replace(/\s/g, '').indexOf(query.replace(/\s/g, '')) >= 0;
  }

  function handleize(value) {
    return clean(value).toLowerCase().replace(/&/g, ' and ').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  function labelNode(row) {
    return one('.integy-v201-filter-label,.integy-v188-model-filter__label,.integy-v187-model-filter__label,[data-filter-label]', row);
  }

  function labelOf(row) {
    var node = labelNode(row);
    return clean(node ? node.textContent : row.textContent).replace(/\s*\(\s*\d[\d,]*\s*\)\s*$/, '');
  }

  function modelHandle(row) {
    return handleize(row && (row.getAttribute('data-integy-v188-handle') || row.getAttribute('data-integy-v427-model-handle') || ''));
  }

  function currentCollectionHandle() {
    var parts = String(location.pathname || '').split('/').filter(Boolean);
    var index = parts.indexOf('collections');
    return index >= 0 && parts[index + 1] ? handleize(parts[index + 1]) : '';
  }

  function isModelRow(row) {
    return !!(row && row.matches && row.matches('[data-integy-v188-model-filter-row],[data-integy-static-model-filter-row],[data-integy-v427-model-chip]'));
  }

  function active(row) {
    return row.classList.contains('is-active') || row.getAttribute('aria-checked') === 'true' || row.getAttribute('aria-current') === 'page';
  }

  function setModelActive(row, selected) {
    row.classList.toggle('is-active', selected);
    row.classList.toggle('integy-v520-current-model', selected);
    row.classList.remove('integy-v31-checkbox-filter--active','active','selected');
    row.setAttribute('role', 'radio');
    row.setAttribute('aria-checked', selected ? 'true' : 'false');
    row.setAttribute('aria-pressed', selected ? 'true' : 'false');
    if (selected) {
      row.setAttribute('aria-current', 'page');
      row.setAttribute('data-integy-v520-current-model', 'true');
    } else {
      row.removeAttribute('aria-current');
      row.removeAttribute('data-integy-v520-current-model');
      row.removeAttribute('data-tag-active');
      row.removeAttribute('data-filter-active');
    }
  }

  function rowSelector() {
    return ':scope > a.integy-v201-static-filter-row,:scope > a[data-integy-v353-static-filter-row],:scope > a.integy-v27-filter-chip';
  }

  function rowsIn(list) {
    var rows = all(rowSelector(), list);
    if (!rows.length) rows = all('a.integy-v201-static-filter-row,a[data-integy-v353-static-filter-row],a.integy-v27-filter-chip', list);
    return rows.filter(function (row, index, items) { return items.indexOf(row) === index && labelOf(row); });
  }

  function routeBrand() {
    var path = String(location.pathname || '').toLowerCase();
    var brands = ['arrma','axial','hpi','losi','tamiya','traxxas','associated'];
    for (var i = 0; i < brands.length; i += 1) if (path.indexOf(brands[i]) >= 0) return brands[i];
    return '';
  }

  var partPattern = /(?:adapter|arm|allen wrench|axle|ball end|bearing|bellcrank|body|body mount|body post|body reamer|brace|bulkhead|bumper|carrier|caster|chassis|connector|cover|differential|drive shaft|esc|fan|gear|gearbox|heatsink|horn|hub|knuckle|led|light|link|motor|mount|nut|pinion|plate|receiver|reamer|rod|roll cage|saver|screw|screwdriver|servo|setup station|shaft|shock|shock tool|skid|spring|spur|stand|starter box|starter boxes|steering|suspension|tie rod|tire|tool|tool bag|tool set|tool tip|tower|tray|turnbuckle|wheel|wire|work stand|wrench|nut driver|hex socket)/i;
  var brandPattern = /^(?:arrma|associated|axial|element rc|hpi|integy|kyosho|losi|redcat|tamiya|team associated|traxxas|vanquish)$/i;
  var colorPattern = /^(?:black|blue|light blue|dark blue|clear|gold|rose gold|gray|green|light green|dark green|grey|gunmetal|gun metal|orange|pink|purple|red|silver|white|yellow|bronze|brown|chrome|natural|smoke|titanium|raw|raw aluminum|aluminum)$/i;
  var statusPattern = /^(?:clearance|on-sale|sale|open-box|scratch-and-dent|scratch-dent|bargain|one-of-a-kind)$/i;

  function groupFor(label) {
    var value = label.toLowerCase();
    if (/^1\s*\/\s*(?:4|5|6|7|8|10|12|14|16|18|24|28|36)$/.test(value)) return 'scale';
    if (colorPattern.test(value)) return 'color';
    if (/^(?:2wd|4wd|4x4|6x6|8x8|2s|3s(?:\s+blx)?|4s(?:\s+blx)?|6s(?:\s+blx)?|8s(?:\s+blx)?|blx|brushless|brushed|mega|nitro)$/.test(value)) return 'platform';
    if (/(?:clearance|on sale|sale|open box|scratch|dent|bargain|one-of-a-kind)/.test(value)) return 'status';
    if (brandPattern.test(value)) return 'brand';
    if (partPattern.test(value)) return 'part';
    return 'more';
  }

  var partPriority = [
    'body mount','shock tower','suspension arm','chassis brace','bumper','drive shaft','gearbox','steering block',
    'hub carrier','caster block','motor mount','servo mount','shock','servo horn','pinion gear','spur gear','body',
    'wheel','tire','bearing','battery strap','axle','ball end'
  ];

  function priority(group, label) {
    var value = label.toLowerCase();
    if (group === 'part') {
      var exact = partPriority.indexOf(value);
      if (exact >= 0) return exact;
      for (var index = 0; index < partPriority.length; index += 1) if (value.indexOf(partPriority[index]) >= 0) return index + 0.5;
      return 100;
    }
    if (group === 'platform') {
      var order = ['2wd','4wd','4x4','2s','3s','3s blx','4s','4s blx','6s','6s blx','8s','8s blx','brushless','brushed','nitro','mega','blx'];
      var found = order.indexOf(value);
      return found >= 0 ? found : 50;
    }
    if (group === 'scale') return Number((value.match(/\d+$/) || [99])[0]);
    return 50;
  }

  function makeHeading(title, group) {
    var heading = document.createElement('h3');
    heading.className = 'integy-v520-filter-subheading';
    heading.setAttribute('data-integy-v520-filter-heading', group);
    heading.textContent = title;
    return heading;
  }

  function makeFilterSection(title, group, rows) {
    var section = document.createElement('section');
    section.className = 'integy-v520-filter-section';
    section.setAttribute('data-integy-v520-filter-section', group);
    section.appendChild(makeHeading(title, group));

    var values = document.createElement('div');
    values.className = 'integy-v520-filter-values';
    values.setAttribute('data-integy-v520-filter-values', group);
    rows.forEach(function (row) {
      row.hidden = false;
      row.removeAttribute('data-integy-v517-collapsed');
      row.removeAttribute('data-integy-v520-collapsed');
      row.classList.add('integy-v520-filter-value');
      values.appendChild(row);
    });
    section.appendChild(values);
    return section;
  }

  function signature(rows) {
    return rows.map(function (row) { return labelOf(row) + '|' + modelHandle(row) + '|' + clean(row.getAttribute('href')); }).join('||');
  }

  function isModelSpecificPage(rows) {
    var current = currentCollectionHandle();
    return !!current && rows.some(function (row) { return modelHandle(row) === current; });
  }

  function organizeMainList() {
    var list = one('[data-integy-v200-static-part-filter-list],.integy-v200-static-part-filter-list,.integy-v201-static-part-filter-list');
    if (!list) return;
    var rows = rowsIn(list);
    if (!rows.length) return;
    var modelRows = all('[data-integy-v188-model-filter-list] > a');
    var modelSpecific = isModelSpecificPage(modelRows) || !!list.closest('[data-integy-v558-model-specific-filters]');
    var signatureValue = signature(rows) + '|model-specific:' + modelSpecific + '|all-visible:true';
    if (list.getAttribute('data-integy-v520-signature') === signatureValue && one('[data-integy-v520-filter-section]', list)) return;

    applying = true;
    var groups = { part: [], platform: [], scale: [], status: [], color: [], brand: [], more: [] };
    var seen = Object.create(null);

    rows.forEach(function (row) {
      var label = labelOf(row);
      var group = groupFor(label);
      if (currentCollectionHandle() === 'off-road-remote-controlled-cars-trucks' && /(?:drift|touring|on[ -]?road|drag)/i.test(label)) {
        row.hidden = true;
        row.setAttribute('data-integy-v520-suppressed', 'non-offroad');
        return;
      }
      if ((group === 'platform' || group === 'scale') && modelSpecific) {
        row.hidden = true;
        row.setAttribute('data-integy-v520-redundant-model-filter', group);
        return;
      }
      row.removeAttribute('data-integy-v520-redundant-model-filter');
      row.removeAttribute('data-integy-v517-redundant-model-filter');
      if (group === 'brand' && routeBrand() && !active(row)) {
        row.hidden = true;
        row.setAttribute('data-integy-v520-suppressed', 'brand');
        return;
      }
      var key = group + ':' + label.toLowerCase() + ':' + clean(row.getAttribute('href'));
      if (seen[key] && !active(row)) { row.remove(); return; }
      seen[key] = true;
      row.hidden = false;
      row.removeAttribute('data-integy-v517-collapsed');
      row.removeAttribute('data-integy-v520-collapsed');
      row.setAttribute('data-integy-v520-filter-group', group);
      groups[group].push(row);
    });

    Object.keys(groups).forEach(function (group) {
      groups[group].sort(function (left, right) {
        var leftLabel = labelOf(left), rightLabel = labelOf(right);
        return priority(group, leftLabel) - priority(group, rightLabel) || leftLabel.localeCompare(rightLabel, undefined, { numeric: true, sensitivity: 'base' });
      });
    });

    /* INTEGY V558 — keep model pages intentionally simple. The selected vehicle
       already defines platform/scale/brand, so buyers only need part, color and
       sale filters. Broad/category pages keep useful platform/brand groups, but
       the vague legacy "More filters" bucket is no longer rendered. */
    var definitions = modelSpecific ? [
      ['part','Part type'],['color','Color / finish'],['status','Sale & clearance']
    ] : [
      ['part','Part type'],['scale','Scale'],['color','Color / finish'],['status','Sale & clearance'],['platform','Vehicle platform / power system'],['brand','Brand']
    ];
    var fragment = document.createDocumentFragment();

    definitions.forEach(function (definition) {
      var group = definition[0], title = definition[1], groupRows = groups[group];
      if (!groupRows.length) return;
      fragment.appendChild(makeFilterSection(title, group, groupRows));
    });

    list.replaceChildren(fragment);
    list.setAttribute('data-integy-v520-signature', signature(rowsIn(list)) + '|model-specific:' + modelSpecific + '|all-visible:true');
    list.classList.add('integy-v520-filter-organized');
    list.classList.remove('integy-v517-filter-organized');

    var details = list.closest('details');
    if (details && !details.hasAttribute('data-integy-v558-open-initialized')) {
      var desktopFilters = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)').matches;
      var hasActiveFilter = rowsIn(list).some(active);
      details.open = desktopFilters || hasActiveFilter;
      details.setAttribute('data-integy-v558-open-initialized','true');
    }
    var summary = details && one('summary span:first-child', details);
    if (summary) summary.textContent = modelSpecific ? 'Part type, color & sale' : 'Part type, scale, color & sale';
    var shell = list.closest('.integy-v200-static-filter-shell,.productgrid--sidebar-section');
    if (shell) shell.setAttribute('data-integy-v520-filter-shell-ready', 'true');
    var helper = shell && one('.integy-sidebar-helper', shell);
    if (helper) helper.textContent = modelSpecific ? 'Choose a part type or color. Open Switch model only when you want a different vehicle.' : 'Choose a compatible model, then narrow by part type, scale, color, or sale status.';
    applying = false;
  }

  var popularModels = ['kraton','outcast','typhon','granite','mojave','infraction','felony','limitless','vorteks','senton','notorious','talion','fireteam','revo','slash','rustler','stampede','maxx','x-maxx','xrt','trx-4'];

  function modelPriority(label, handle, current) {
    if (handle && handle === current) return -1000;
    var value = label.toLowerCase();
    for (var index = 0; index < popularModels.length; index += 1) if (value.indexOf(popularModels[index]) >= 0) return index;
    return 100;
  }


  function v626RootPath() {
    try {
      var rootPath = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
      if (rootPath) return rootPath.charAt(rootPath.length - 1) === '/' ? rootPath : rootPath + '/';
    } catch (error) {}
    return '/';
  }

  function currentTagHandles() {
    var tags = [];
    try {
      var parts = location.pathname.split('/').filter(Boolean);
      var index = parts.indexOf('collections');
      if (index >= 0 && parts[index + 2]) tags = decodeURIComponent(parts.slice(index + 2).join('/')).split('+');
      var queryTags = new URLSearchParams(location.search || '').get('integy_filter');
      if (queryTags) tags = tags.concat(queryTags.split('+'));
    } catch (error) {}
    var seen = Object.create(null);
    return tags.map(handleize).filter(function (tag) { if (!tag || seen[tag]) return false; seen[tag] = true; return true; });
  }

  function safeModelTags() {
    return currentTagHandles().filter(function (tag) { return colorPattern.test(tag) || statusPattern.test(tag); });
  }

  function modelUrl(handle) {
    var tags = safeModelTags();
    var path = v626RootPath() + 'collections/' + handle + (tags.length ? '/' + tags.map(encodeURIComponent).join('+') : '');
    var params = new URLSearchParams();
    try {
      var current = new URLSearchParams(location.search || '');
      ['filter.v.availability','integy_stock','grid_list','sort_by'].forEach(function (key) { if (current.has(key)) params.set(key, current.get(key)); });
    } catch (error) {}
    var query = params.toString();
    return path + (query ? '?' + query : '');
  }

  function ensureModelSearch(list, total, index) {
    var wrapper = one('[data-integy-v520-model-search]', list);
    if (!wrapper) {
      wrapper = document.createElement('div');
      wrapper.className = 'integy-v520-model-search';
      wrapper.setAttribute('data-integy-v520-model-search','true');
      wrapper.innerHTML = '<label><span class="visually-hidden">Search compatible models</span><input type="search" inputmode="search" autocomplete="off" placeholder="Find your model" aria-label="Search compatible models" data-integy-v520-model-search-input data-compatible-model-search-input></label><span role="status" aria-live="polite" data-integy-v520-model-total data-compatible-model-count></span>';
    }
    wrapper.setAttribute('data-compatible-model-search','true');
    if (!list.id) list.id = 'integy-v524-compatible-model-list-' + (index + 1);
    list.setAttribute('data-compatible-model-list','true');
    var input = one('[data-integy-v520-model-search-input]', wrapper);
    if (input) {
      input.setAttribute('data-compatible-model-search-input','true');
      input.setAttribute('aria-label','Search compatible models');
      input.removeAttribute('aria-autocomplete');
      input.removeAttribute('aria-controls');
      input.removeAttribute('aria-expanded');
    }
    var totalNode = one('[data-integy-v520-model-total]', wrapper);
    if (totalNode) {
      totalNode.setAttribute('data-compatible-model-count','true');
      totalNode.setAttribute('role','status');
      totalNode.setAttribute('aria-live','polite');
      totalNode.textContent = total + (total === 1 ? ' model' : ' models');
    }
    return wrapper;
  }

  function organizeModelList(details, list, index) {
    if (!details || !list) return;
    var rows = all(':scope > a', list).filter(function (row) { return isModelRow(row) && labelOf(row); });
    if (!rows.length) return;

    var current = currentCollectionHandle();
    rows.forEach(function (row) {
      row.style.removeProperty('order');
      var handle = modelHandle(row);
      setModelActive(row, !!handle && handle === current);
      if (handle) row.setAttribute('href', modelUrl(handle));
      row.setAttribute('data-integy-v520-model-row','true');
      row.setAttribute('data-compatible-model-option','true');
      row.removeAttribute('data-integy-v517-collapsed');
      row.removeAttribute('data-integy-v520-collapsed');
    });

    var input = one('[data-integy-v520-model-search-input]', list);
    var rawQuery = clean(input && input.value);
    var query = normalizeModelSearch(rawQuery);
    var signatureValue = signature(rows) + '|current:' + current + '|query:' + query + '|component-search:v527';
    var needs = list.getAttribute('data-integy-v520-model-signature') !== signatureValue;

    /* INTEGY V558 — do not force a 40+ model selector open on a model-specific
       collection. Root collection desktop pages may start open; model pages and
       touch/mobile pages start collapsed. Initialize once so later observers do
       not fight a buyer who manually opens/closes the control. */
    if (!details.hasAttribute('data-integy-v558-model-open-initialized')) {
      var desktopModelNav = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)').matches;
      var currentIsModel = rows.some(function (row) { return modelHandle(row) === current; });
      details.open = desktopModelNav && !currentIsModel;
      details.setAttribute('data-integy-v558-model-open-initialized','true');
    }
    if (!needs) return;

    /* V527 focus guard: never replace/reparent the model-search control while it
       owns keyboard focus. Reconcile visibility in place and let the next
       legitimate post-focus refresh perform structural organization if needed. */
    if (input && document.activeElement === input) {
      applyModelSearch(input);
      return;
    }

    applying = true;
    all('[data-integy-v515-model-more],[data-integy-v517-model-more],[data-integy-v520-model-more],[data-integy-v517-model-empty],[data-integy-v520-model-empty]', list).forEach(function (node) { node.remove(); });
    var search = ensureModelSearch(list, rows.length, index);
    search.className = 'integy-v520-model-search';
    search.setAttribute('data-integy-v520-model-search','true');
    search.setAttribute('data-compatible-model-search','true');
    input = one('input[type="search"]', search);
    if (input) {
      input.setAttribute('data-integy-v520-model-search-input','true');
      input.setAttribute('data-compatible-model-search-input','true');
      input.setAttribute('aria-label','Search compatible models');
      input.removeAttribute('aria-autocomplete');
      input.removeAttribute('aria-controls');
      input.removeAttribute('aria-expanded');
    }
    var totalNode = one('[data-integy-v520-model-total]', search);
    if (totalNode) {
      totalNode.setAttribute('data-integy-v520-model-total','true');
      totalNode.setAttribute('data-compatible-model-count','true');
      totalNode.setAttribute('role','status');
      totalNode.setAttribute('aria-live','polite');
    }

    rows.sort(function (left, right) {
      return modelPriority(labelOf(left), modelHandle(left), current) - modelPriority(labelOf(right), modelHandle(right), current) || labelOf(left).localeCompare(labelOf(right), undefined, { numeric: true, sensitivity: 'base' });
    });

    var matches = 0;
    rows.forEach(function (row) {
      var matchesQuery = modelMatches(labelOf(row), query);
      if (matchesQuery) matches += 1;
      row.hidden = !matchesQuery;
      row.classList.toggle('is-filtered-out', !matchesQuery);
      if (matchesQuery) row.removeAttribute('aria-hidden');
      else row.setAttribute('aria-hidden','true');
    });
    if (totalNode) totalNode.textContent = query
      ? matches + ' of ' + rows.length + (rows.length === 1 ? ' model' : ' models')
      : rows.length + (rows.length === 1 ? ' model' : ' models');

    var fragment = document.createDocumentFragment();
    fragment.appendChild(search);
    rows.forEach(function (row) { fragment.appendChild(row); });

    if (query && !matches) {
      var empty = document.createElement('p');
      empty.className = 'integy-v520-model-empty';
      empty.setAttribute('data-integy-v520-model-empty','true');
      empty.setAttribute('data-compatible-model-empty','true');
      empty.setAttribute('role','status');
      empty.textContent = 'No compatible models found.';
      fragment.appendChild(empty);
    }

    list.replaceChildren(fragment);
    list.setAttribute('data-integy-v520-model-signature', signature(rows) + '|current:' + current + '|query:' + query + '|component-search:v527');
    list.classList.add('integy-v520-model-list-ready');
    list.classList.remove('integy-v517-model-list-ready');
    var summary = one('summary span:first-child', details);
    if (summary) summary.textContent = rows.some(function (row) { return modelHandle(row) === current; }) ? 'Switch model' : 'Choose your model';
    applying = false;
  }

  function organizeModels() {
    all('[data-integy-v188-model-filter-group]').forEach(function (details, index) {
      organizeModelList(details, one('[data-integy-v188-model-filter-list]', details), index);
    });
  }

  function refresh() {
    root.classList.add('integy-v520-filter-experience');
    all('[data-integy-v517-filter-more],[data-integy-v520-filter-more],[data-integy-v517-model-more],[data-integy-v520-model-more]').forEach(function (node) { node.remove(); });
    organizeModels();
    organizeMainList();
  }

  function schedule(delay) {
    if (applying) return;
    window.clearTimeout(timer);
    timer = window.setTimeout(refresh, typeof delay === 'number' ? delay : 80);
  }

  function modelClick(event) {
    var row = event.target && event.target.closest ? event.target.closest('[data-integy-v188-model-filter-row],[data-integy-static-model-filter-row],[data-integy-v427-model-chip]') : null;
    if (!row || event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var handle = modelHandle(row);
    if (!handle) return;
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    location.assign(modelUrl(handle));
  }

  document.addEventListener('click', modelClick, true);


  /* INTEGY V527 — stable compatible-model search.
     Do not rebuild/reparent the model list while the buyer is typing. Earlier
     implementations called organizeModels() on every input event, which could
     replaceChildren() on the list and move the focused search input after the
     first keystroke. V527 only changes row visibility and the existing status
     text, then updates the organizer signature so unrelated MutationObserver
     refreshes do not immediately rebuild the same list. */
  function setStableText(node, text) {
    if (!node) return;
    var child = node.firstChild;
    if (child && child.nodeType === 3 && node.childNodes.length === 1) child.nodeValue = text;
    else node.textContent = text;
  }

  function applyModelSearch(input) {
    if (!input || !input.closest) return;
    var list = input.closest('[data-integy-v188-model-filter-list],[data-compatible-model-list]');
    if (!list) return;
    var rows = all(':scope > a', list).filter(function (row) { return isModelRow(row) && labelOf(row); });
    if (!rows.length) return;

    var query = normalizeModelSearch(input.value);
    var matches = 0;
    rows.forEach(function (row) {
      var match = modelMatches(labelOf(row), query);
      if (match) matches += 1;
      row.hidden = !match;
      row.classList.toggle('is-filtered-out', !match);
      if (match) row.removeAttribute('aria-hidden');
      else row.setAttribute('aria-hidden', 'true');
    });

    var totalNode = one('[data-integy-v520-model-total],[data-compatible-model-count]', list);
    if (totalNode) {
      setStableText(totalNode, query
        ? (matches ? matches + ' of ' + rows.length + (rows.length === 1 ? ' model' : ' models') : 'No compatible models found')
        : rows.length + (rows.length === 1 ? ' model' : ' models'));
    }

    var current = currentCollectionHandle();
    list.setAttribute('data-integy-v520-model-signature', signature(rows) + '|current:' + current + '|query:' + query + '|component-search:v527');
  }

  function modelSearchInput(event) {
    var input = event.target;
    if (!input || !input.matches || !input.matches('[data-integy-v520-model-search-input],[data-compatible-model-search-input]')) return;
    applyModelSearch(input);
  }

  document.addEventListener('input', modelSearchInput);
  document.addEventListener('search', modelSearchInput);

  window.addEventListener('resize', function () { schedule(100); }, { passive: true });
  window.addEventListener('pageshow', function () { schedule(0); });
  document.addEventListener('shopify:section:load', function () { schedule(0); });
  document.addEventListener('integy:filter-rendered', function () { schedule(0); });
  document.addEventListener('integy:v429:filter-rendered', function () { schedule(0); });

  function boot() {
    refresh();
    var collectionRoot = one('main') || document.body;
    if (collectionRoot && window.MutationObserver) {
      observer = new MutationObserver(function (mutations) {
        if (applying) return;
        var relevant = mutations.some(function (mutation) {
          return mutation.type === 'childList' && (mutation.addedNodes.length || mutation.removedNodes.length);
        });
        if (relevant) schedule(60);
      });
      observer.observe(collectionRoot, { childList: true, subtree: true });
    }
  }

  window.IntegyV520FilterExperience = { version: 'V527', refresh: refresh, modelUrl: modelUrl, applyModelSearch: applyModelSearch };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
}());

/* INTEGY V520 — deployment and catalog-view stabilization.
   Keeps blank search deterministic after Safari bfcache restores and rescues
   the two Mini Traxxas collections from the validated compatibility index while
   Shopify automated collection membership is being corrected. */
(function () {
  'use strict';

  if (window.IntegyV520Stabilization) return;

  var root = document.documentElement;

  function one(selector, scope) {
    try { return (scope || document).querySelector(selector); }
    catch (error) { return null; }
  }

  function all(selector, scope) {
    try { return Array.prototype.slice.call((scope || document).querySelectorAll(selector)); }
    catch (error) { return []; }
  }

  function searchQuery() {
    try { return String(new URLSearchParams(location.search).get('q') || '').trim(); }
    catch (error) { return ''; }
  }

  function fixPlaceholder(scope) {
    all('input[type="search"],input[name="q"]', scope || document).forEach(function (input) {
      var placeholder = String(input.getAttribute('placeholder') || '').trim();
      if (!placeholder || /^search\.form\.placeholder$/i.test(placeholder)) {
        input.setAttribute('placeholder', 'What are you looking for?');
      }
      if (input.getAttribute('aria-label') === 'search.form.placeholder') {
        input.setAttribute('aria-label', 'What are you looking for?');
      }
    });
  }

  function fixBlankSearch() {
    if (!/\/search\/?$/.test(location.pathname) || searchQuery()) {
      root.classList.remove('integy-v520-search-blank');
      return;
    }

    root.classList.add('integy-v520-search-blank');
    fixPlaceholder(document);

    all('.search--section .productgrid--sidebar,.search--section .productgrid--utils-container,.search--section .productgrid--utils-sticky-intersection,.search--section .productgrid--filters').forEach(function (node) {
      node.hidden = true;
      node.setAttribute('aria-hidden', 'true');
    });

    var outer = one('.search--section .productgrid--outer');
    if (outer) {
      outer.classList.remove('layout--has-sidebar');
      outer.classList.add('layout--no-sidebar');
    }
  }

  function hideInternalMaintenanceCopy(scope) {
    all('p,small,div', scope || document).forEach(function (node) {
      if (node.children.length) return;
      var text = String(node.textContent || '');
      if (/V38b catalog|collection membership is being updated/i.test(text)) {
        node.hidden = true;
        node.setAttribute('aria-hidden', 'true');
      }
    });
  }

  function collectionHandle() {
    var match = location.pathname.match(/^\/collections\/([^/?#]+)/i);
    return match ? String(match[1]).toLowerCase() : '';
  }

  function compatibleWith(record, handle) {
    var tags = ' ' + String(record && record.tags || '').toLowerCase().replace(/[^a-z0-9-]+/g, ' ') + ' ';
    var title = String(record && record.title || '').toLowerCase();
    if (tags.indexOf(' ' + handle + ' ') >= 0) return true;
    if (handle === 'hop-up-parts-for-traxxas-mini-xrt') return /mini\s+xrt/.test(title);
    if (handle === 'hop-up-parts-for-traxxas-mini-slash-4x4') return /mini\s+slash\s*4x4/.test(title);
    return false;
  }

  function dedupeBySku(records) {
    var seen = Object.create(null);
    return (records || []).filter(function (record) {
      var sku = String(record && record.sku || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
      if (!sku || seen[sku]) return false;
      seen[sku] = true;
      return true;
    }).sort(function (left, right) {
      return String(left.sku || '').localeCompare(String(right.sku || ''), undefined, { numeric: true, sensitivity: 'base' });
    });
  }

  function nativeCollectionCount(scope) {
    return all('.productgrid--items > .productgrid--item,.productgrid--items > [data-product-item]', scope || document).length;
  }

  function renderMiniRescue(records, handle) {
    var collection = one('.collection--section');
    var wrapper = one('.productgrid--wrapper', collection || document);
    if (!wrapper || !records.length) return;

    var api = window.IntegyV520Search || window.IntegyV508Search || window.IntegyV506Search;
    if (!api || typeof api.renderExactCard !== 'function') return;

    var existing = one('[data-integy-v520-mini-rescue]', wrapper);
    if (!existing) {
      existing = document.createElement('section');
      existing.className = 'integy-v520-rescue-results';
      existing.setAttribute('data-integy-v520-mini-rescue', handle);
      var masthead = one('.productgrid--masthead', wrapper);
      wrapper.insertBefore(existing, masthead ? masthead.nextSibling : wrapper.firstChild);
    }

    var modelName = handle.indexOf('mini-xrt') >= 0 ? 'Traxxas Mini XRT' : 'Traxxas Mini Slash 4X4';
    existing.innerHTML = '<header class="integy-v520-rescue-results__header"><h2>' + modelName + ' compatible parts</h2><p>Products verified by SKU compatibility data. In-stock items are shown first.</p></header>' +
      '<div class="integy-v520-rescue-grid">' + records.map(function (record, index) {
        if (!Number.isFinite(Number(record.price_cents))) record.price_cents = Number(record.price || 0);
        return api.renderExactCard(record, index);
      }).join('') + '</div>';

    all('.productgrid--no-results,.pagination,.pagination--container,[data-integy-v453-fallback-grid]', wrapper).forEach(function (node) {
      node.hidden = true;
      node.setAttribute('aria-hidden', 'true');
    });
    var outer = one('.productgrid--outer', collection || document);
    if (outer) {
      outer.classList.remove('layout--has-sidebar');
      outer.classList.add('layout--no-sidebar', 'integy-v520-mini-rescued');
    }
    var rescuedCount = records.length;
    var noticeCount = one('[data-integy-v453-server-fallback] strong', collection || document);
    if (noticeCount) noticeCount.textContent = rescuedCount + ' compatible products found';
    var countNode = one('[data-integy-collection-product-count]', collection || document) || one('.integy-collection-meta .integy-chip--accent', collection || document);
    if (countNode) {
      countNode.textContent = rescuedCount + (rescuedCount === 1 ? ' product' : ' products');
      countNode.setAttribute('data-integy-rescued-count', String(rescuedCount));
    }
    if (outer) {
      outer.setAttribute('data-integy-result-count', String(rescuedCount));
      outer.setAttribute('data-integy-v168-base-count', String(rescuedCount));
    }
    var sectionCount = one('[data-section-data]', collection || document);
    if (sectionCount) sectionCount.setAttribute('data-integy-v520-rescued-count', String(rescuedCount));
    root.classList.add('integy-v520-mini-collection-ready');
  }

  function miniRequestedStockMode() {
    try {
      var params = new URLSearchParams(location.search || '');
      var custom = String(params.get('integy_stock') || '').toLowerCase();
      if (custom === 'all') return '';
      if (custom === 'out') return 'out';
      if (custom === 'in') return 'in';
      var nativeValue = String(params.get('filter.v.availability') || '');
      if (nativeValue === '0') return 'out';
      if (nativeValue === '1') return 'in';
    } catch (error) {}
    return '';
  }

  function miniProductHandle(record) {
    try {
      var match = new URL(String(record && record.url || ''), location.origin).pathname.match(/^\/products\/([^/?#]+)/i);
      return match ? decodeURIComponent(match[1]) : '';
    } catch (error) { return ''; }
  }

  function hydrateMiniLiveRecord(record) {
    var productHandle = miniProductHandle(record);
    if (!productHandle || !window.fetch) return Promise.reject(new Error('missing product handle'));
    var rootPath = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    return fetch(rootPath + 'products/' + encodeURIComponent(productHandle) + '.js', { credentials: 'same-origin' }).then(function (response) {
      if (!response.ok) throw new Error('product fetch failed');
      return response.json();
    }).then(function (product) {
      var live = Object.assign({}, record);
      var variants = product && Array.isArray(product.variants) ? product.variants : [];
      var targetSku = String(record && record.sku || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
      var liveVariant = variants.find(function (variant) {
        return String(variant && variant.sku || '').toUpperCase().replace(/[^A-Z0-9]/g, '') === targetSku;
      }) || variants.find(function (variant) { return !!(variant && variant.available); }) || variants[0] || null;
      live.available = liveVariant ? !!liveVariant.available : !!product.available;
      if (liveVariant && Number.isFinite(Number(liveVariant.price))) live.price_cents = Number(liveVariant.price);
      else if (Number.isFinite(Number(product.price))) live.price_cents = Number(product.price);
      if (liveVariant && Number.isFinite(Number(liveVariant.compare_at_price))) live.compare_at_price_cents = Number(liveVariant.compare_at_price || 0);
      else if (Number.isFinite(Number(product.compare_at_price))) live.compare_at_price_cents = Number(product.compare_at_price);
      if (product.featured_image) live.image = product.featured_image;
      live._integy_v605_live_verified = true;
      live._integy_v605_variant_id = liveVariant && liveVariant.id ? String(liveVariant.id) : '';
      live._integy_v605_variant_count = variants.length;
      return live;
    });
  }

  function sortMiniRecords(records) {
    var params;
    var sortBy = '';
    try {
      params = new URLSearchParams(location.search || '');
      sortBy = String(params.get('sort_by') || '').toLowerCase();
    } catch (error) {}
    var copy = (records || []).slice();
    if (sortBy === 'title-ascending' || sortBy === 'title-descending') {
      copy.sort(function (left, right) {
        var cmp = String(left.title || '').localeCompare(String(right.title || ''), undefined, { numeric: true, sensitivity: 'base' });
        return sortBy === 'title-descending' ? -cmp : cmp;
      });
      return copy;
    }
    if (sortBy === 'price-ascending' || sortBy === 'price-descending') {
      copy.sort(function (left, right) {
        var cmp = Number(left.price_cents || left.price || 0) - Number(right.price_cents || right.price || 0);
        return sortBy === 'price-descending' ? -cmp : cmp;
      });
      return copy;
    }
    copy.sort(function (left, right) {
      if (left.available === right.available) {
        return String(left.sku || '').localeCompare(String(right.sku || ''), undefined, { numeric: true, sensitivity: 'base' });
      }
      return left.available ? -1 : 1;
    });
    return copy;
  }

  function rescueMiniCollection() {
    var handle = collectionHandle();
    if (handle !== 'hop-up-parts-for-traxxas-mini-xrt' && handle !== 'hop-up-parts-for-traxxas-mini-slash-4x4') return;

    var collection = one('.collection--section');
    hideInternalMaintenanceCopy(collection || document);
    var fallbackGrid = one('[data-integy-v453-fallback-grid]', collection || document);
    if (nativeCollectionCount(collection || document) > 0 && !fallbackGrid) return;

    var api = window.IntegyV520Search || window.IntegyV508Search || window.IntegyV506Search;
    if (!api || typeof api.localSearch !== 'function') return;
    var query = handle.indexOf('mini-xrt') >= 0 ? 'mini xrt' : 'mini slash 4x4';

    api.localSearch(query).then(function (records) {
      records = dedupeBySku((records || []).filter(function (record) {
        return compatibleWith(record, handle);
      }));
      if (!records.length) return;
      return Promise.all(records.map(hydrateMiniLiveRecord)).then(function (liveRecords) {
        var stockMode = miniRequestedStockMode();
        if (stockMode === 'in') liveRecords = liveRecords.filter(function (record) { return record.available; });
        if (stockMode === 'out') liveRecords = liveRecords.filter(function (record) { return !record.available; });
        liveRecords = sortMiniRecords(liveRecords);
        if (liveRecords.length) renderMiniRescue(liveRecords.slice(0, 48), handle);
        else root.classList.add('integy-v520-mini-collection-ready');
      });
    }).catch(function () {
      // Keep the server-rendered fallback visible if live hydration cannot complete.
      root.classList.add('integy-v520-mini-collection-ready');
    });
  }

  function cleanOldSearchState() {
    fixPlaceholder(document);
    if (!document.body || document.body.classList.contains('integy-v501-search-active')) return;
    all('.live-search:not(.integy-v501-body-search)').forEach(function (search) {
      search.classList.remove('live-search--active', 'visible', 'active');
      search.removeAttribute('style');
    });
  }

  function boot() {
    root.classList.add('integy-v520-stabilized');
    fixBlankSearch();
    rescueMiniCollection();
    cleanOldSearchState();
  }

  window.IntegyV520Stabilization = {
    version: 'V520',
    refresh: boot,
    rescueMiniCollection: rescueMiniCollection,
    fixBlankSearch: fixBlankSearch
  };

  document.addEventListener('shopify:section:load', function () {
    window.requestAnimationFrame(boot);
  });
  window.addEventListener('pageshow', function () {
    window.requestAnimationFrame(boot);
  });
  window.addEventListener('orientationchange', function () {
    window.setTimeout(cleanOldSearchState, 80);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
}());

/* INTEGY V520 — compact drawer DOM hardening.
   Historical filter owners can redraw the sidebar after opening; this final
   pass restores flat, all-visible categories without rebuilding URLs/counts. */
(function () {
  'use strict';
  if (window.IntegyV520FilterDrawerRepair) return;

  var root = document.documentElement;
  var timer = 0;
  var observer = null;

  function all(selector, scope) {
    try { return Array.prototype.slice.call((scope || document).querySelectorAll(selector)); }
    catch (error) { return []; }
  }
  function one(selector, scope) {
    try { return (scope || document).querySelector(selector); }
    catch (error) { return null; }
  }
  function compact() {
    return !!(window.matchMedia && window.matchMedia('(max-width: 989px), (pointer: coarse) and (max-width: 1200px)').matches);
  }
  function contextFor(panel) {
    var path = String(location.pathname || '').toLowerCase();
    var models = !!one('[data-integy-v188-model-filter-list]', panel);
    var current = !!one('[data-integy-v188-model-filter-row][aria-current="page"],[data-integy-v188-model-filter-row].is-active', panel);
    if (/all-rc-tools|rc-tools|tool-sets/.test(path)) return { placeholder: 'Search tool types or finishes', helper: 'Search tool types or finishes' };
    if (models && current) return { placeholder: 'Search parts or colors', helper: 'Search parts or colors' };
    if (models) return { placeholder: 'Search models or parts', helper: 'Search models or parts' };
    return { placeholder: 'Search filters', helper: 'Search available filters' };
  }
  function repair(panel) {
    if (!panel || !compact()) return;
    panel.classList.add('integy-v520-filter-panel-ready');

    all('details', panel).forEach(function (details) {
      details.open = true;
      details.setAttribute('open', '');
      details.setAttribute('data-integy-v520-flat-details', 'true');
    });

    all([
      '.filter-item--toggle-more',
      '[data-filter-show-more]',
      '[data-integy-v517-filter-more]',
      '[data-integy-v519-filter-more]',
      '[data-integy-v520-filter-more]'
    ].join(','), panel).forEach(function (node) {
      node.hidden = true;
      node.setAttribute('aria-hidden', 'true');
    });

    var shell = one('.integy-v200-static-filter-shell', panel);
    if (shell) {
      var title = one(':scope > .productgrid--sidebar-title', shell);
      var helper = one(':scope > .integy-sidebar-helper', shell);
      if (title) title.setAttribute('data-integy-v520-duplicate-chrome', 'true');
      if (helper) helper.setAttribute('data-integy-v520-duplicate-chrome', 'true');
    }

    var context = contextFor(panel);
    var input = one('.integy-v466-filter-search input', panel);
    if (input && input.getAttribute('placeholder') !== context.placeholder) input.setAttribute('placeholder', context.placeholder);
    var active = one('.integy-v466-filter-active', panel);
    if (active && !/^Selected:/i.test(String(active.textContent || '').trim())) active.textContent = context.helper;

    all('.integy-v520-filter-section', panel).forEach(function (section) {
      section.style.removeProperty('order');
      section.setAttribute('data-integy-v520-full-width-section', 'true');
    });
  }
  function run() {
    timer = 0;
    if (!compact()) return;
    var panel = one('.integy-v466-filter-panel-active') || one('[data-productgrid-sidebar]') || one('.productgrid--sidebar');
    repair(panel);
  }
  function schedule() {
    if (timer) return;
    timer = window.setTimeout(run, 30);
  }
  function start() {
    run();
    if (!document.body || observer) return;
    observer = new MutationObserver(function (mutations) {
      if (mutations.some(function (mutation) {
        return mutation.type === 'childList' || mutation.attributeName === 'open' || mutation.attributeName === 'class';
      })) schedule();
    });
    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class','open','hidden'] });
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('orientationchange', schedule, { passive: true });
    document.addEventListener('shopify:section:load', schedule);
  }

  window.IntegyV520FilterDrawerRepair = { version: 'V520', refresh: schedule };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
}());
